import { ApolloError, useQuery } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { useAuth } from '@guildeducationinc/guild-auth';
import {
  GET_PROGRAMS_BY_UUID,
  ProgramsByUuidResponse,
  ProgramsByUuidVariables,
} from '@src/graphql/home/queries';
import { Server } from '@src/components/GqlProvider/GqlProvider';

/**
 * Fetch programs from the catalog service by UUIDs
 *
 * @packageDocumentation
 */

const useGetProgramsByUuid = (programUuids: string[] = []) => {
  const { user } = useAuth();

  const onError = (error: ApolloError): void => {
    datadogRum.addError(error, {
      message: `There was an error getting program data from the catalog service: ${error}`,
      type: 'catalog-service',
    });
  };

  const { data, error, loading } = useQuery<ProgramsByUuidResponse, ProgramsByUuidVariables>(
    GET_PROGRAMS_BY_UUID,
    {
      context: {
        server: Server.CATALOG,
      },
      skip: !user?.id || programUuids?.length === 0,
      variables: {
        programUuids,
      },
      onError,
    }
  );

  return {
    programData: data?.programs,
    loading,
    error,
  };
};

export default useGetProgramsByUuid;
